export const locales = {
  en: require('./en')
};
const messages = {
  icon: {
    title: '图标',
    tip: '图片要求为： 128px*128px，png、jpg格式、小于100KB',
    errorTip: ''
  },
  CnName: {
    title: '中文名',
    title1: '应用中文名称',
    title2: '轻应用中文名称',
    placeholder: '例如：投票',
    tip: '名称清晰易懂，建议2-3个字最佳，支持中文、字母、数字',
    errorTip: '应用名称与其他应用名称重复'
  },
  EnName: {
    title: '英文名',
    title1: '应用英文名称',
    title2: '轻应用英文名称',
    placeholder: '例如：vote',
    tip: '名称过长将影响显示，建议与中文字数长度保持一致，支持字母、数字',
    tip1: '名称过长将影响显示，建议与中文字数长度保持一致，支持字母、数字',
    errorTip: '英文名重复'
  },
  CnIntroduce: {
    title: '中文简介',
    tip: '简要介绍应用提供的服务和带来的价值，300字以内',
    errorTip: ''
  },
  EnIntroduce: {
    title: '英文简介',
    tip: '简要介绍应用提供的服务和带来的价值，600字符以内',
    errorTip: ''
  },
  userSupport: {
    title: '用户支持',
    placeholder: '例如：张三1383838428',
    tip: '填写负责解答用户问题的人员联系方式，包括电话，邮箱等',
    errorTip: ''
  },
  keyWords: {
    title: '关键词',
    placeholder: '例如：vote',
    tip: '填写应用的关键字信息，方便用户搜索，关键字以英文" , "分隔，例如：打卡, 考勤',
    errorTip: ''
  },
  backendAdd: {
    title: '应用介绍地址',
    placeholder: '例如：http://welink.huawei.com',
    tip: '选填，填写应用提供者的官网或者技术支持页面，方便用户联系开发者，支持http(s)地址',
    errorTip: ''
  },
  privacyLinkCN: {
    title: '中文隐私地址',
    placeholder: '例如：https://welink.huaweicloud.com/privacy',
    tip: '选填, 填写应用隐私声明服务地址，支持http(s)地址',
    tipRequire: '必填, 填写应用隐私声明服务地址，支持http(s)地址',
    errorTip: ''
  },
  privacyLinkEN: {
    title: '英文隐私地址',
    placeholder: '例如：https://welink.huaweicloud.com/privacy',
    tip: '选填, 填写应用隐私声明服务地址，支持http(s)地址',
    tipRequire: '必填, 填写应用隐私声明服务地址，支持http(s)地址',
    errorTip: ''
  },
  ipWhiteList: {
    title: 'IP白名单',
    placeholder: '例如：192.168.20.1',
    tip: '仅IP地址正确的服务器可调用接口，以英文符号( , )分割；如：企业内部网段，请务必确认是公司出口IP；不配置则无限制',
    errorTip: ''
  }


};

export default { locales, ...messages };
